<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.1961 7.29691L6.12306 13.3699C4.53431 14.9587 4.53431 17.5346 6.12306 19.1233V19.1233C7.71182 20.7121 10.2877 20.7121 11.8764 19.1233L20.1869 10.8129C21.4226 9.57717 21.4226 7.57371 20.1869 6.33801V6.33801C18.9512 5.10232 16.9477 5.10232 15.712 6.33801L14.5933 7.45673L7.56141 14.4886C6.67877 15.3713 6.67877 16.8023 7.56141 17.685V17.685V17.685C8.44405 18.5676 9.87509 18.5676 10.7577 17.685L16.6709 11.7718"
      stroke="currentColor"
    />
  </svg>
</template>
